export default __webpack_public_path__ + "static/media/grid.5276fc72.svg";